<template>
  <div class="hello" style="overflow: hidden;">
    <!-- <hhead></hhead> -->
    <register></register>
    <!-- <nnav></nnav> -->
    <!-- <foot></foot> -->
  </div>
</template>

<script>
import hhead from '../../components/header/index';
import foot from '../../components/footer/index';
import nnav from '../../components/nav/index';
import register from '../../components/register/index';

export default {
  components: { hhead, foot, nnav, register },
  name: 'login',
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/view/login/index.vue